const InvoiceIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15 5.29297V16.5C15 17.163 14.7364 17.7987 14.2676 18.2676C13.7987 18.7364 13.163 19 12.5 19H2.5C1.83696 19 1.20126 18.7364 0.732422 18.2676C0.263581 17.7987 0 17.163 0 16.5V2.5C0 1.83696 0.263581 1.20126 0.732422 0.732422C1.20126 0.263581 1.83696 0 2.5 0H9.70703L15 5.29297ZM2.5 1C2.10218 1 1.72076 1.15815 1.43945 1.43945C1.15815 1.72076 1 2.10218 1 2.5V16.5C1 16.8978 1.15815 17.2792 1.43945 17.5605C1.72076 17.8419 2.10218 18 2.5 18H12.5C12.8978 18 13.2792 17.8419 13.5605 17.5605C13.8419 17.2792 14 16.8978 14 16.5V6H10.5C10.1022 6 9.72076 5.84185 9.43945 5.56055C9.15815 5.27924 9 4.89783 9 4.5V1H2.5ZM10.5 15H8.5V14H10.5V15ZM10.5 11H4.5V10H10.5V11ZM5.5 5H4.5V4H5.5V5ZM10 4.5C10 4.63261 10.0527 4.75975 10.1465 4.85352C10.2403 4.94728 10.3674 5 10.5 5H13.293L10 1.70703V4.5Z"
                fill="var(--desktop-bookings-button)"
            />
        </svg>
    );
};

export default InvoiceIcon;
